export async function createUser(formData) {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/user/register`;
  const payload = {
    mail: formData.mail,
    password: formData.password || undefined,
    firstName: formData.firstName || undefined,
    lastName: formData.lastName || undefined,
    phone: formData.phone || undefined,
    lang: formData.lang || "en",
    job: formData.job || undefined,
    roles: [formData.role],
    organization: formData.organization || undefined,
    custom: formData.custom || undefined,
    groups: [formData.groupId],
    sendCredentials: formData.sendCredentials,
    cancelTheInvitationAfterDays: formData.cancelTheInvitationAfterDays,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    console.log(result)
    console.log(typeof(result))
    if (response.ok) {
      return { success: true, data: result };
    } else {
      return { success: false, message: result.message || "API error" };
    }
  } catch (error) {
    return { success: false, message: "Network error" };
  }
}
